import type { HSLA } from "../hsla-color/hsla-color";
import { calculateHueFromRgb } from "../rgba-color/calculate-hue-from-rgb";
import type { RGB } from "../rgba-color/rgb-color";
import type { RgbaArray } from "../rgba-color/rgba-array";

function rgbaToHsla(rgba: RgbaArray): HSLA;
function rgbaToHsla(rgba: RGB & { alpha?: number }): HSLA;
function rgbaToHsla(rgba: (RGB & { alpha?: number }) | RgbaArray): HSLA {
    const { red, green, blue } = Array.isArray(rgba)
        ? { red: rgba[0], green: rgba[1], blue: rgba[2] }
        : rgba;
    const alpha = (Array.isArray(rgba) ? rgba[3] : rgba.alpha) ?? 1;
    const min = Math.min(red, green, blue);
    const max = Math.max(red, green, blue);
    const light = (max + min) / 2;

    const delta = max - min;
    const saturation =
        red === 0 && green === 0 && blue === 0
            ? 0
            : red === 1 && green === 1 && blue === 1
              ? 1
              : light > 0.5
                ? delta / (2 - max - min)
                : delta / (max + min);
    if (isNaN(saturation)) {
        // eslint-disable-next-line no-console
        console.log("RGBA TO HSLA", {
            input: rgba,
            saturation,
            light,
            delta,
            max,
            min,
        });
    }
    const hue = calculateHueFromRgb({ red, green, blue }, { min, max, delta });

    return {
        hue,
        saturation,
        light,
        alpha,
    };
}
export { rgbaToHsla };
